import BackupDateList from "../../../components/backup/backup.date.list";

const BackupDateSelect = () => <BackupDateList />;

export default BackupDateSelect;
